import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { BookmarksState } from 'src/app/bookmarks/state/bookmarks.state';
import { Observable, Subject } from 'rxjs';
import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';
import { takeUntil, filter } from 'rxjs/operators';
import { BookmarkActionsEnum } from 'src/app/bookmarks/components/bookmark-actions/bookmark-actions.component';
import { OrganizationsState } from 'src/app/organizations/state/organizations.state';
import { ExploreService } from 'src/app/explore/explore.service';
import { StoryState } from 'src/app/story/state/story.state';
import { StoryModel } from 'src/app/story/models/story.model';
import { StoryService } from 'src/app/story/story.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-view-internal-header',
  templateUrl: './view-internal-header.component.html',
  styleUrls: ['./view-internal-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ViewInternalHeaderComponent implements OnInit, OnDestroy {
  // ---------- Observables ----------
  @Select(StoryState.getStory)
  story$: Observable<StoryModel>;
  
  
  // ---------- Class Variables ---------- 
  ngUnsubscribe = new Subject();
  id = '';
  type = '';
  category = '';

  
  // ---------- Lifecycle ----------
  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store,
    private changeDetectorRef: ChangeDetectorRef,
    private exploreService: ExploreService,
    private storyService: StoryService
  ) { }

  ngOnInit() {
    this.story$
      .pipe(
        filter(story => story != null),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(story => {
        this.id = this.activatedRoute.snapshot.queryParams.id;
        this.type = this.storyService.getStoryType(this.activatedRoute.snapshot.queryParams.id);
        this.category = this.exploreService.getStoryCategory(story);
        this.changeDetectorRef.markForCheck();
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  
  get bookmarkActions(): BookmarkActionsEnum[] {
    const organization = this.store.selectSnapshot(OrganizationsState.getOrganization);

    return [
      BookmarkActionsEnum.CopyLink, 
      BookmarkActionsEnum.Embed,
      BookmarkActionsEnum.CopyBookmark,
      // add optional organization actions
      ...organization ? [BookmarkActionsEnum.CopyTeamBookmark] : []
    ];
  }

}
